import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { logger } from '@tuic/logger';

import { Oss } from '../../index';
import { CacheTag } from '../../utils';

import type { Filter } from '../../generated/oss';
import type { Locale } from '@tuic/i18n';

export type ExcursionsBaseData = {
  ports?: Filter;
  excursionCategories?: Filter;
  excursionDifficulties?: Filter;
};

const getExcursionsBaseData = async (
  tripCode: string,
  locale: Locale,
): Promise<ExcursionsBaseData> => {
  const { data, error } = await Oss.getExcursionsBaseData({
    query: {
      locale,
      tripCode,
    },
  });

  if (error) {
    logger.error(
      `Could not fetch excursion base data. Trip: ${tripCode}, Locale: ${locale}`,
    );
    logger.error(error);

    return {};
  }

  return data ?? {};
};

export const cachedGetExcursionsBaseData = (
  tripCode: string,
  locale: Locale,
): Promise<ExcursionsBaseData> =>
  remember(
    serializeDataToCacheKey(['oss', 'getExcursionsBaseData', locale, tripCode]),
    () => getExcursionsBaseData(tripCode, locale),
    {
      tags: [
        CacheTag.oss,
        CacheTag.excursionResource,
        CacheTag.getExcursionsBaseData,
      ],
      ttl: 600,
    },
  );
